import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { persistReducer, persistStore } from "redux-persist";
import type { PersistConfig } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { apiSlice, loginSlice } from "../services/http";
import { legacyFilterKeysTransform, PERSIST_VERSION, persistMigrate } from "./persist-migrations";
import { rootReducer } from "./rootReducer";

const persistConfig: PersistConfig<ReturnType<typeof rootReducer>> = {
  key: "root",
  version: PERSIST_VERSION,
  migrate: persistMigrate,
  transforms: [legacyFilterKeysTransform],
  storage,
  whitelist: [
    "filterStores",
    "filterStoreEmail",
    "filterLackOfReconciliation",
    "overviewFilter",
    "selecaoFilter",
    "drillFilter",
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false, immutableCheck: false })
      .concat(loginSlice.middleware)
      .concat(apiSlice.middleware),
});

setupListeners(store.dispatch);

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export type ApplicationState = RootState;

export * from "./slices";
